import { Thermometer } from "~/types/devices";

type GaugeHandle = {
  chart: google.visualization.Gauge;
  data: google.visualization.DataTable;
  formatter: google.visualization.NumberFormat;
};

export class GaugeTemperature {
  charts: Record<string, GaugeHandle> = {};
  thermometers: Thermometer[];
  options: google.visualization.GaugeChartOptions = {
    width: 300,//"100%",
    minorTicks: 10,
    majorTicks: ["0", "10", "20", "30", "40", "50"],
    min: 0,
    max: 50,
    //yellowFrom: required_temperature - hysteresis,
    //yellowTo: required_temperature,
    redFrom: 30,
    redTo: 50,
  };

  constructor(thermometers: Thermometer[]) {
    this.thermometers = thermometers;

    // Load Google Charts
    google.charts.load("current", { packages: ["gauge"] });
    google.charts.setOnLoadCallback(this.drawGauges);
  }

  drawGauges = () => {
    for (const thermometer of this.thermometers) {
      const element = document.getElementById('chart_' + thermometer.mac_address);
      if (!element) continue;

      const chart = new google.visualization.Gauge(element);
      const data = google.visualization.arrayToDataTable([['Label', 'Value'], ['°C', 0]]);
      const formatter = new google.visualization.NumberFormat({ pattern: '0.0' });
      formatter.format(data, 1);

      this.charts[thermometer.mac_address] = { chart, data, formatter };
      chart.draw(data, this.options);
    }
  };

  updateGauge = (id: string, value: number) => {
    const handle = this.charts[id];
    if (handle) {
      handle.data.setValue(0, 1, value);
      handle.formatter.format(handle.data, 1);
      handle.chart.draw(handle.data, this.options);
    }
  };

}